export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13648.c2154fcf.jpg";